
import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from '../service/bc-account-client.service';
import { IMyDpOptions } from 'mydatepicker';

export interface AlertModel {
  clientObj;
}

@Component({
  selector: 'app-bc-property-search',
  templateUrl: './bc-property-search.component.html',
  styleUrls: ['./bc-property-search.component.scss'],
  providers: [BcAccountClientService]
})

export class BcPropertySearchComponent extends DialogComponent<AlertModel, boolean> implements AlertModel {
  
  clientObj;
  private clientID;
  private propertySearch = [];
  private isReturn = false;
  private dateReturn;
  private property;

  private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels:{su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

  constructor(dialogService: DialogService,
    private bcAccountClientService:BcAccountClientService) {                  
    super(dialogService);
  }


ngOnInit(){
  this.clientID = this.clientObj.ID
  this.getPropertySearch();
}

getPropertySearch(){
  this.bcAccountClientService.getPropertySearch(this.clientID).subscribe(result => {
    if (result.Success) {
      this.propertySearch = result.Result;
    if (this.propertySearch.length > 0){
      this.propertySearch[0].DataPatrimonio? this.isReturn = false : this.isReturn = true;
    }
      console.log("Visitas", this.propertySearch);
    } else {
      console.log("deu erro aqui", result);
    }
    }, error => {
      console.log(error);
  });
}

requestPropertySearch(){
  this.bcAccountClientService.requestPropertySearch(this.clientID).subscribe(result => {
    if (result.Success) {
      this.getPropertySearch();
    } else {
      console.log("deu erro aqui requestPropertySearch", result);
    }
    }, error => {
      console.log(error);
  });
}

returnPropertySearch(){

  const tempDateReturn = this.dateReturn? this.dateReturn.date.year+"-"+this.dateReturn.date.month+"-"+this.dateReturn.date.day: null

  this.bcAccountClientService.returnPropertySearch(this.propertySearch[0].ID, this.clientID, this.property, tempDateReturn).subscribe(result => {
    if (result.Success) {
      this.dateReturn = null;
      this.property = null;
      this.getPropertySearch();
    } else {
      console.log("deu erro aqui returnPropertySearch", result);
      }
    }, error => {
      console.log(error);
  });
}



confirm(){
    this.close();
  }

}


// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-property-search/bc-property-search.component.ts